import { combineReducers } from 'redux';
import imageUploader from '../imageUploader/imageUploader.reducer.js';
import userAuthenticationInfo from '../useUserAuthenticationInfo/userAuthenticationInfo.reducer';
import churchCampus from './churchCampus';
import churchCampuses from './churchCampuses';
import churchCampusesCache from './churchCampusesCache';
import worshipServices from './worshipServices.reducer.js';

const reducers = combineReducers({
    churchCampus,
    churchCampuses,
    churchCampusesCache,
    imageUploader,
    userAuthenticationInfo,
    worshipServices,
});

export default reducers;
